<template>
  <div>
    <b-button-toolbar class="pb-1">
      <b-button-group class="mx-1 mb-1 mb-md-0" v-if="!hideSearchResetButtons" :size="toolbarButtonSize">
        <b-dropdown variant="primary" split text="Search" v-on:click="executeSearch()" :size="toolbarButtonSize">
          <b-dropdown-item variant="info" v-on:click="clear()">Reset</b-dropdown-item>
        </b-dropdown>
      </b-button-group>
      <b-button-group class="mx-1 mb-1 mb-md-0" v-if="!hideExport && (tableKey || exportKey)" :size="toolbarButtonSize">
        <b-dropdown variant="info" split text="Export" v-on:click="exportData(false)" :size="toolbarButtonSize">
          <b-dropdown-item variant="info" v-on:click="exportData(true)">Export (use Column settings)</b-dropdown-item>
        </b-dropdown>
      </b-button-group>
      <b-button-group class="mx-1 mb-1 mb-md-0 d-lg-none" v-if="sortableFields && sortableFields.length" :size="toolbarButtonSize">
        <b-dropdown text="Sort By" variant="secondary" :size="toolbarButtonSize">
          <b-dropdown-form>
            <b-form-group label="Field">
              <select class="form-control-sm" v-model="syncedSortBy">
                <option v-for="field in sortableFields" :key="field.key" :value="field.key">{{ field.label }}</option>
              </select>
            </b-form-group>
            <b-form-checkbox class="mb-3" v-model="syncedSortDesc">Descending</b-form-checkbox>
          </b-dropdown-form>
        </b-dropdown>
      </b-button-group>
      <b-button-group class="mx-1 mb-1 mb-md-0" v-if="allowColumnCustomization" :size="toolbarButtonSize">
        <b-button variant="warning" :size="toolbarButtonSize" @click="showColumnsModal">Columns</b-button>
      </b-button-group>
      <slot name="toolbar-buttons"></slot>
      <generic-default-parameters v-model="syncedFilters" ref="defaultFilters" :filter-key="defaultParametersFilterKey" :table-id="tableId" @alert="alert" v-if="defaultParametersFilterKey" :toolbar-button-size="toolbarButtonSize"></generic-default-parameters>
    </b-button-toolbar>
    <b-modal id="modalColumns" ref="modalColumns" title="Reconfigure Columns" size="xxl" @hide="hideModal" scrollable ok-only>
      <b-alert variant="info" show>Drag and Drop columns to order and Double Click / Tap to toggle visiblity. Critical columns containing actions and record IDs cannot be hidden.</b-alert>
      <b-button-toolbar class="pb-1">
        <b-button-group class="mx-1 mb-1 mb-md-0" v-if="allowColumnCustomization" :size="toolbarButtonSize">
          <b-button variant="warning" v-on:click="resetFields()" v-if="resetable">Reset to Default</b-button>
          <b-button variant="success" v-on:click="showAllFields()" v-if="hiddenFields.length">Show All</b-button>
          <b-button variant="danger" v-on:click="hideAllFields()" v-if="visibleFields.length">Hide All</b-button>
        </b-button-group>
      </b-button-toolbar>
      <b-list-group>
        <draggable v-model="orderedFields" draggable=".app-web-table-column" @end="dragFieldToPosition">
          <b-list-group-item :variant="fieldVariant(field)" v-for="(field, fieldIndex) in orderedFields" :key="field.key" class="app-web-table-column" @dblclick="toggleField(field)">
            {{ field.label }}
            <b-button-toolbar class="float-right">
              <b-button-group class="mx-1 mb-1 mb-md-0" size="sm" v-if="fieldState(field) !== ''">
                <b-button variant="success" v-on:click="showField(field)" v-if="fieldState(field) === 'hidden'" title="Show">
                  <span class="fas fa-eye"></span>
                </b-button>
                <b-button variant="danger" v-on:click="hideField(field)" v-if="fieldState(field) === 'visible'" title="Hide">
                  <span class="fas fa-eye-slash"></span>
                </b-button>
              </b-button-group>
              <b-button-group class="mx-1 mb-1 mb-md-0" size="sm" v-if="fieldIndex > 0 || fieldIndex < orderedFields.length - 1">
                <b-button variant="info" v-on:click="moveFieldToPosition(field, 0)" v-if="fieldIndex > 0" title="Move To Top">
                  <span class="fas fa-angle-double-up"></span>
                </b-button>
                <b-button variant="info" v-on:click="moveFieldByOffset(field, -1)" v-if="fieldIndex > 0" title="Move Up">
                  <span class="fas fa-angle-up"></span>
                </b-button>
                <b-button variant="info" v-on:click="moveFieldByOffset(field, 1)" v-if="fieldIndex < orderedFields.length - 1" title="Move Down">
                  <span class="fas fa-angle-down"></span>
                </b-button>
                <b-button variant="info" v-on:click="moveFieldToPosition(field, orderedFields.length)" v-if="fieldIndex < orderedFields.length - 1" title="Move To Bottom">
                  <span class="fas fa-angle-double-down"></span>
                </b-button>
              </b-button-group>
            </b-button-toolbar>
          </b-list-group-item>
        </draggable>
      </b-list-group>      
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: "generic-table-toolbar",
    props: {
      fields: {
        type: Array
      },
      sortBy: {
        type: String
      },
      sortDesc: {
        type: Boolean
      },
      search: {
        type: Function
      },
      clear: {
        type: Function
      },
      alert: {
        type: Function
      },
      filters: {
        type: Object
      },
      tableKey: {
        type: String
      },
      hideDefaultParameters: {
        type: Boolean,
        default: false
      },
      hideSearchResetButtons: {
        type: Boolean,
        default: false
      },
      allowColumnCustomization: {
        type: Boolean,
        default: true
      },
      tableId: {
        type: Number,
        required: true
      },
      hideExport: {
        type: Boolean,
        default: false
      },
      exportKey: {
        type: String
      },
      toolbarButtonSize: {
        type: String,
        default: "md"
      }
    },
    created() {
    },
    data() {
      return {
        fieldToggles: {
          hidden: { },
          version: 2,
          visible: { },
          order: [ ]
        },
        resetable: false,
        sortableFields: [],
        visibleFields: [],
        hiddenFields: [],
        orderedFields: []
      };
    },
    mounted() {
      this.updateFields();
    },
    computed: {
      syncedSortBy: {
        get() {
          return this.sortBy;
        },
        set(newValue) {
          this.$emit('update:sortBy', newValue);
        }
      },
      syncedSortDesc: {
        get() {
          return this.sortDesc;
        },
        set(newValue) {
          this.$emit('update:sortDesc', newValue);
        }
      },
      syncedFilters: {
        get() {
          return this.filters;
        },
        set(newValue) {
          this.$emit('update:filters', newValue);
        }
      },
      defaultParametersFilterKey() {
        if (this.tableKey && !this.hideDefaultParameters) {
          return this.tableKey + '-filters';
        }
        return null;
      }
    },
    methods: {
      executeSearch() {
        if (this.search) {
          appHelpers.audit.logSearch(this.tableKey, this.exportKey);
          this.search();
        }
      },
      updateFields() {
        if (this.allowColumnCustomization) {
          this.fieldToggles = window.appHelpers.table.getFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId);
        } else {
          this.fieldToggles = {
            hidden: { },
            version: 2,
            visible: { },
            order: [ ]
          };
        }

        this.resetable = false;
        this.hiddenFields = [ ];
        this.visibleFields = [ ];
        if (this.fields && this.fields.length) {
          this.fields.forEach((field) => {
            this.resetable = this.resetable || !!this.fieldToggles.hidden[field.key] || !!this.fieldToggles.visible[field.key];
            if (!field.alwaysVisible && !field.stickyColumn && ['actions', 'item', 'select'].indexOf(field.key.toLowerCase()) < 0) {
              if (this.fieldToggles.hidden[field.key]
                || (field.isHidden && !this.fieldToggles.visible[field.key])
              ) {
                this.hiddenFields.push(field);
              } else {
                this.visibleFields.push(field);
              }
            }
          });
        }

        this.sortableFields = [];
        if (this.fields && this.fields.length) {
          this.fields.forEach((field) => {
            if (['actions', 'item', 'select'].indexOf(field.key.toLowerCase()) < 0 && field.sortable) {
              this.sortableFields.push(field);
            }
          });
        }

        let originalOrder = [];
        if (this.fields && this.fields.length) {
          this.fields.forEach((field) => {
            originalOrder.push(field);
          });
        }
        let customOrder = [];
        if (this.fieldToggles.order && this.fieldToggles.order.length) {
          this.resetable = true;
          this.fieldToggles.order.forEach((order) => {
            let fieldIndex = originalOrder.findIndex((origField) => origField.key === order);
            if (fieldIndex >= 0) {
              customOrder.push(originalOrder[fieldIndex]);
              originalOrder.splice(fieldIndex, 1);
            }
          });
          originalOrder.forEach((originalOrderField) => {
            if (['actions', 'item', 'select'].indexOf(originalOrderField.key.toLowerCase()) >= 0 || originalOrderField.stickyColumn) {
              customOrder.splice(0, 0, originalOrderField);
            } else {
              customOrder.push(originalOrderField);
            }
          });
        } else {
          customOrder = originalOrder;
        }

        this.orderedFields = customOrder;
      },
      save(tempFlag) {
        if (this.$refs.defaultFilters) {
          return this.$refs.defaultFilters.save(tempFlag);
        }
      },
      load(allowTempFlag) {
        if (this.$refs.defaultFilters) {
          return this.$refs.defaultFilters.load(allowTempFlag);
        }
      },
      toggleField(field) {
        switch(this.fieldState(field))
        {
          case 'hidden':
            this.showField(field);
            break;
          case 'visible':
            this.hideField(field);
            break;
        }
      },
      hideField(field) {
        if (!field.isHidden) {
          this.fieldToggles.hidden[field.key] = true;
        }
        if (field.isHidden && this.fieldToggles.visible[field.key])
        {
          delete this.fieldToggles.visible[field.key];
        }
        window.appHelpers.table.setFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId, this.fieldToggles);
        this.updateFields();
      },
      showField(field) {
        if (this.fieldToggles.hidden[field.key]) {
          delete this.fieldToggles.hidden[field.key];
        }
        if (field.isHidden)
        {
          this.fieldToggles.visible[field.key] = true;
        }
        window.appHelpers.table.setFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId, this.fieldToggles);
        this.updateFields();
      },
      resetFields() {
        this.fieldToggles = {
          version: 2,
          hidden: { },
          visible: { },
          order: [ ]
        };
        window.appHelpers.table.setFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId, this.fieldToggles);
        this.updateFields();
      },
      showAllFields() {
        this.hiddenFields.forEach((field) => {
          if (this.fieldToggles.hidden[field.key]) {
            delete this.fieldToggles.hidden[field.key];
          }
          if (field.isHidden) {
            this.fieldToggles.visible[field.key] = true;
          }
        });
        window.appHelpers.table.setFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId, this.fieldToggles);
        this.updateFields();
      },
      hideAllFields() {
        this.visibleFields.forEach((field) => {
          if (this.fieldToggles.visible[field.key]) {
            delete this.fieldToggles.visible[field.key];
          }
          if (!field.isHidden) {
            this.fieldToggles.hidden[field.key] = true;
          }
        });
        window.appHelpers.table.setFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId, this.fieldToggles);
        this.updateFields();
      },
      moveFieldByOffset(field, offset) {
        let fieldIndex = this.orderedFields.indexOf(field);
        this.orderedFields.splice(fieldIndex, 1);
        this.orderedFields.splice(fieldIndex + offset, 0, field);        
        this.fieldToggles.order = this.orderedFields.map((orderedField) => orderedField.key);

        window.appHelpers.table.setFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId, this.fieldToggles);
        this.updateFields();
      },
      moveFieldToPosition(field, position) {
        let fieldIndex = this.orderedFields.indexOf(field);
        this.orderedFields.splice(fieldIndex, 1);
        this.orderedFields.splice(position, 0, field);        
        this.fieldToggles.order = this.orderedFields.map((orderedField) => orderedField.key);

        window.appHelpers.table.setFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId, this.fieldToggles);
        this.updateFields();
      },
      dragFieldToPosition(event) {
        if (event.newDraggableIndex !== event.oldDraggableIndex) {
          this.fieldToggles.order = this.orderedFields.map((orderedField) => orderedField.key);

          window.appHelpers.table.setFieldToggles(this.tableKey, window.appState.currentTenantId, this.tableId, this.fieldToggles);
          this.updateFields();
        }
      },
      cleared(filters, sortBy, sortDesc) {
        this.syncedSortBy = sortBy;
        this.syncedSortDesc = sortDesc;
        if (this.$refs.defaultFilters) {
          this.$refs.defaultFilters.cleared(filters, sortBy, sortDesc);
        }
      },
      exportData(withCustomizations) {
        this.$emit('exportData', withCustomizations);
      },
      fieldState(field) {
        if (this.hiddenFields.indexOf(field) >= 0) {
          return 'hidden';
        }
        if (this.visibleFields.indexOf(field) >= 0) {
          return 'visible';
        }
        return '';
      },
      fieldVariant(field) {
        switch(this.fieldState(field))
        {
          case 'hidden':
            return 'danger';
          case 'visible':
            return 'success';
          default:
            return 'warning';
        }
      },
      showColumnsModal() {
        this.updateFields();

        this.$refs.modalColumns.show();
      },
      hideModal(event) {
        if (event.trigger === 'backdrop') {
          event.preventDefault();
        } else {
          this.updateTable();
        }
      },
      updateTable() {
        this.$forceUpdate();
        this.$emit('fieldsChanged');
      },
    }
  }
</script>